"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var AccessTokenItem = (function (_super) {
    __extends(AccessTokenItem, _super);
    function AccessTokenItem(props) {
        var _this = _super.call(this, props) || this;
        _this.valueInput = react_1.default.createRef();
        _this.isEditing = false;
        _this.handleEdit = function () {
            _this.isEditing = true;
        };
        _this.handleChange = function (field, newValue) {
            _this[field] = newValue;
        };
        _this.reset = function () {
            _this.updatedDescription = undefined;
            _this.isEditing = false;
            _this.validationErrors = undefined;
        };
        _this.handleAccept = function () { return __awaiter(_this, void 0, Promise, function () {
            var updatedDescription, _a, id, description, validationErrors;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedDescription = this.updatedDescription;
                        _a = this.props.accessToken, id = _a.id, description = _a.description;
                        return [4, this.props.onAdd({ description: updatedDescription !== null && updatedDescription !== void 0 ? updatedDescription : description, id: id })];
                    case 1:
                        validationErrors = _b.sent();
                        if (!validationErrors) {
                            this.reset();
                        }
                        else {
                            this.validationErrors = validationErrors;
                        }
                        return [2];
                }
            });
        }); };
        _this.handleCancel = function () {
            var description = _this.props.accessToken.description;
            var onDelete = _this.props.onDelete;
            if (!description) {
                onDelete(_this.props.accessToken);
            }
            else {
                _this.reset();
            }
        };
        _this.handleKeyboardShortcuts = function (event) {
            if (event.key === "Enter") {
                _this.handleAccept();
            }
            if (event.key === "Escape") {
                _this.handleCancel();
            }
        };
        if (!props.accessToken.id) {
            _this.isEditing = true;
        }
        return _this;
    }
    AccessTokenItem.prototype.componentDidMount = function () {
        var _a;
        if (this.isEditing) {
            (_a = this.valueInput.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    AccessTokenItem.prototype.render = function () {
        var _a;
        var _b = this.props, accessToken = _b.accessToken, onDelete = _b.onDelete;
        var _c = this, isEditing = _c.isEditing, updatedDescription = _c.updatedDescription, validationErrors = _c.validationErrors;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("access-tokens-panel__row", { "access-tokens-panel__row--edit": isEditing }) }, isEditing ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "access-tokens-panel__column-value global-substitution__column-value--edit" },
                react_1.default.createElement(kaleidoscope_1.TextInput, { ref: this.valueInput, label: "Description", labelHidden: true, size: kaleidoscope_1.TextInputSize.Small, value: updatedDescription !== null && updatedDescription !== void 0 ? updatedDescription : accessToken.description, onChange: this.handleChange.bind(null, "updatedDescription"), error: (_a = validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.find(function (err) { return err.field === "description"; })) === null || _a === void 0 ? void 0 : _a.error, onKeyDown: this.handleKeyboardShortcuts }),
                react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Tick, null), onClick: this.handleAccept }),
                react_1.default.createElement(kaleidoscope_1.IconButton, { size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Close, null), onClick: this.handleCancel })))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "access-tokens-panel__column-value" },
                react_1.default.createElement("span", { className: "access-tokens-panel__value" }, accessToken.description),
                react_1.default.createElement(kaleidoscope_1.OptionMenu, { size: "small", button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.OptionsVertical, null), size: kaleidoscope_1.ButtonSize.Small }) },
                    react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: onDelete.bind(null, accessToken), destructive: true }, "Delete")))))));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "updatedDescription", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "isEditing", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "validationErrors", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "handleEdit", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "handleChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "reset", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "handleAccept", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AccessTokenItem.prototype, "handleCancel", void 0);
    AccessTokenItem = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AccessTokenItem);
    return AccessTokenItem;
}(react_1.Component));
exports.default = AccessTokenItem;
